import { baseApi } from "@/redux/api/baseApi";

export const paymentApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    createPaymentIntent: builder.mutation({
      query: (data) => ({
        url: "/payments/create-intent",
        method: "POST",
        body: data,
      }),
    }),
    createPaymentIntentByToken: builder.mutation({
      query: (data) => ({
        url: "/payments/create-intent",
        method: "POST",
        body: data,
      }),
    }),
    confirmPayment: builder.mutation({
      query: (data) => ({
        url: "/payments/confirm",
        method: "POST",
        body: data,
      }),
    }),
    createSecondPaymentIntent: builder.mutation({
      query: (data) => ({
        url: "/payments/second-intent",
        method: "POST",
        body: data,
      }),
    }),
    getPaymentByAppointment: builder.query({
      query: (appointmentId: string) => ({
        url: `/payments/appointment/${appointmentId}`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useCreatePaymentIntentMutation,
  useCreatePaymentIntentByTokenMutation,
  useConfirmPaymentMutation,
  useCreateSecondPaymentIntentMutation,
  useGetPaymentByAppointmentQuery,
} = paymentApi;
